import { flatten } from "es-toolkit";

import type { TPartInteractionWithImage } from "~/database/types";
import type { GetSessionResult } from "~/modules.server/session/get-session";
import type { IdentifiedPart } from "~/types";

export interface HydratedSessionParts {
    present: TPartInteractionWithImage[];
    other: IdentifiedPart[];
    suspectedParts: IdentifiedPart[];
}

const mapToFrontendFormat = (parts: IdentifiedPart[] = []) =>
    parts.map((part) => ({
        ...part,
        partId: ((part as unknown as { id: string }).id ||
            part.partId) as string,
    }));

// AIDEV-NOTE: SSR prefetch and browser refetch must preserve the same three
// pipeline buckets or hydration silently removes v2 synthesized parts.
export function hydrateSessionParts(
    responseData: GetSessionResult,
): HydratedSessionParts {
    const rawParts = responseData.session?.rawReport?.parts;
    const hasParts =
        Boolean(responseData.parts) ||
        Boolean(rawParts?.other) ||
        Boolean(rawParts?.suspectedParts);

    if (!hasParts) {
        return { present: [], other: [], suspectedParts: [] };
    }

    return {
        present: flatten(responseData.parts ?? []),
        other: mapToFrontendFormat(flatten(rawParts?.other ?? [])),
        suspectedParts: mapToFrontendFormat(
            flatten(rawParts?.suspectedParts ?? []),
        ),
    };
}
